import { useState } from 'react';
import axios from 'axios';

const useApiData = (url) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (cacheKey) => {
    setIsLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${url}/${cacheKey}/`);
      setData(response.data);
    } catch (error) {
      setError(error);
    } finally {
      setIsLoading(false);
    }
  };

  return { data, isLoading, error, fetchData };
};

export default useApiData;